import React from 'react';
import { ShipCustomization } from './types';
import './ControlPanel.css';

interface ControlPanelProps {
  customization: ShipCustomization;
  onChange: (customization: ShipCustomization) => void;
}

export const ControlPanel: React.FC<ControlPanelProps> = ({ customization, onChange }) => {
  const handleChange = (field: keyof ShipCustomization, value: any) => {
    onChange({
      ...customization,
      [field]: value,
    });
  };

  return (
    <div className="control-panel">
      <h3>Ship Customization</h3>

      {/* Hull Customization */}
      <div className="control-group">
        <label>Hull Color</label>
        <div className="color-picker-wrapper">
          <input
            type="color"
            value={customization.hullColor}
            onChange={(e) => handleChange('hullColor', e.target.value)}
            className="color-input"
          />
          <span className="color-value">{customization.hullColor}</span>
        </div>
      </div>

      <div className="control-group">
        <label>Hull Style</label>
        <select
          value={customization.hullStyle}
          onChange={(e) => handleChange('hullStyle', e.target.value as any)}
          className="select-input"
        >
          <option value="merchant">Merchant (round)</option>
          <option value="galleon">Galleon (high-hulled)</option>
          <option value="brigantine">Brigantine (sleek)</option>
        </select>
      </div>

      {/* Sail Customization */}
      <div className="control-group">
        <label>Sail Color</label>
        <div className="color-picker-wrapper">
          <input
            type="color"
            value={customization.sailColor}
            onChange={(e) => handleChange('sailColor', e.target.value)}
            className="color-input"
          />
          <span className="color-value">{customization.sailColor}</span>
        </div>
      </div>

      <div className="control-group">
        <label>Sail Pattern</label>
        <select
          value={customization.sailPattern}
          onChange={(e) => handleChange('sailPattern', e.target.value as any)}
          className="select-input"
        >
          <option value="plain">Plain</option>
          <option value="striped">Striped</option>
          <option value="skull">Skull</option>
        </select>
      </div>

      {/* Figurehead */}
      <div className="control-group">
        <label>Figurehead</label>
        <select
          value={customization.figurehead}
          onChange={(e) => handleChange('figurehead', e.target.value as any)}
          className="select-input"
        >
          <option value="skull">Skull</option>
          <option value="dragon">Dragon</option>
          <option value="crown">Crown</option>
          <option value="anchor">Anchor</option>
        </select>
      </div>

      {/* Flag Customization */}
      <div className="control-group">
        <label>Flag Color</label>
        <div className="color-picker-wrapper">
          <input
            type="color"
            value={customization.flagColor}
            onChange={(e) => handleChange('flagColor', e.target.value)}
            className="color-input"
          />
          <span className="color-value">{customization.flagColor}</span>
        </div>
      </div>

      <div className="control-group">
        <label>Flag Pattern</label>
        <select
          value={customization.flagPattern}
          onChange={(e) => handleChange('flagPattern', e.target.value as any)}
          className="select-input"
        >
          <option value="jollyroger">Jolly Roger</option>
          <option value="crossbones">Crossbones</option>
          <option value="stripes">Fire</option>
        </select>
      </div>
    </div>
  );
};
